<template>
    <!-- Enlace interno -->
    <router-link v-if="to" :to="to" role="menuitem" :class="classes" @click.native="onClick">
        <i v-if="icon" :class="[icon, iconClasses]"></i>
        <span><slot></slot></span>
    </router-link>

    <!-- Enlace externo / descarga -->
    <a v-else-if="href" :href="href" :target="target" role="menuitem" :class="classes"
        :rel="target === '_blank' ? 'noopener' : null" @click="onClick">
        <i v-if="icon" :class="[icon, iconClasses]"></i>
        <span><slot></slot></span>
    </a>

    <!-- Acción -->
    <button v-else type="button" role="menuitem" :class="classes" @click="onClick">
        <i v-if="icon" :class="[icon, iconClasses]"></i>
        <span><slot></slot></span>
    </button>
</template>

<script>
export default {
    name: 'BaseDropdownItem',
    inject: {
        baseDropdown: { default: null },
    },
    props: {
        to: { type: [String, Object], default: null },
        href: { type: String, default: null },
        target: { type: String, default: null },
        icon: { type: String, default: '' },
        variant: { type: String, default: 'default', validator: (v) => ['default', 'danger'].includes(v) },
    },
    computed: {
        classes() {
            const base = 'tw:flex tw:w-full tw:items-center tw:gap-2.5 tw:px-3 tw:py-2 tw:rounded-lg tw:text-xs tw:font-medium tw:text-left tw:no-underline tw:hover:no-underline tw:bg-transparent tw:border-0 tw:cursor-pointer tw:transition-colors';
            const variants = {
                default: 'tw:text-slate-700 tw:hover:bg-slate-100 tw:hover:text-slate-900',
                danger: 'tw:text-red-600 tw:hover:bg-red-50 tw:hover:text-red-700',
            };
            return `${base} ${variants[this.variant]}`;
        },
        iconClasses() {
            return this.variant === 'danger'
                ? 'tw:w-4 tw:text-center tw:text-red-400'
                : 'tw:w-4 tw:text-center tw:text-slate-400';
        },
    },
    methods: {
        onClick(event) {
            this.$emit('click', event);
            if (this.baseDropdown) this.baseDropdown.close();
        },
    },
};
</script>
